module.exports = __webpack_public_path__ + "img/pic_2_zh.5fba2506.png";